import { stylesheet } from 'astroturf';
import { FunctionalComponent } from 'preact';
import clsx from 'clsx';
import { getFormattedUnixTimestamp } from '##/utils/DateTimeHelpers';
import { LiveShow } from '##/services/tenApi/collections/types';
import { getPipeSeperator } from '##/utils';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .carousel-item {
    display: flex;
    flex-direction:row;
    margin-bottom: pxToVw(10);   
  }

  .carousel-card-container {
    position: relative;
    width: pxToVw(268);
    height: pxToVw(106);
    margin-left: pxToVw(2);
    padding: pxToVw(20) pxToVw(12) pxToVw(20);
    color: $pure-white;
    font-family: barlow;
    border-width: pxToVw(2);
    border-style: solid;
    border-color: transparent;
    background: transparent linear-gradient(270deg, #121212 0%, #202020 100%) 0% 0% no-repeat padding-box;
    :global(.current-focus) & {
      border-color:var(--borderColor);
      border-radius: pxToVw(4);
      a {
        color: $pure-black;
      }
    }
  }
  .focused-card-container {
    padding: pxToVw(14) pxToVw(12) pxToVw(13);
  }

  .title {
    text-transform: capitalize;
    font-size: pxToVw(16);
    text-overflow: ellipsis;
    line-height: pxToVw(15);
    white-space: nowrap;
    width: pxToVw(235);
    overflow: hidden;
    margin-top: pxToVw(6);
    margin-bottom: pxToVw(6);
  }

  .time {
    font-size: pxToVw(13);
    color: $secondary-grey;
    margin: 0;
    margin-bottom: pxToVw(10);
    height:unset;
  }

  .focused-label {
    display:flex;
    justify-content:center;
    align-items:center;
    margin-left:-(pxToVw(12));
    width: pxToVw(48);
    height: pxToVw(17);
    background:var(--borderColor);
  }

  .label-text {
    font-size: pxToVw(12);
    font-weight: 800;
    height: pxToVh(14);
  }
`;

const NextLiveCarouselTile: FunctionalComponent<LiveShow & {
  color: string;
  focused: boolean;
  label: string;
}> = (props) => {
  const border = props.color;
  const focusStyle = {
    '--borderColor': border,
  };

  const { rating, ratings } = props;

  return (
    <div className={styles.carouselItem} style={focusStyle}>
      <div
        className={clsx(
          styles.carouselCardContainer,
          props.focused && styles.focusedCardContainer,
        )}
      >
        {props.focused ? (
          <div className={styles.focusedLabel} style={focusStyle}>
            <span className={styles.labelText}>{props.label}</span>
          </div>
        ) : null}
        <p className={styles.title}>{props.title || 'No Stream Available'}</p>
        <p className={styles.time}>
          {getFormattedUnixTimestamp(props.startTime)}
          {' - '}
          {getFormattedUnixTimestamp(props.endTime)}
          {Boolean(rating || ratings) && (
            <>
              {getPipeSeperator(4)}
              {rating || ratings}
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default NextLiveCarouselTile;
